// @flow

import React from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { body, filters } from 'core/config';
import { searchJobs as t } from 'helpers/translation';
import BtnRounded from 'components/BtnRounded';
import BtnTransparent from 'components/BtnTransparent';

type Props = {
  search: any,
  urlSearch: any,
  updateSearch: Function,
  showFilters: boolean,
  toggleVisibility: Function,
  pushToSearch: Function
};

const job_language_url_param = 'job_language_ids'

export default ({ search, urlSearch, updateSearch, showFilters, toggleVisibility, pushToSearch }: Props) => {
  const locales = filters.filter(item => item.url_param === job_language_url_param)[0].data

  const handleClick = () => {
    body.style.overflow = body.style.overflow === 'hidden' ? 'auto' : 'hidden';

    toggleVisibility();
  };

  const clearFilters = () => {
    updateSearch({});
    body.style.overflow = 'auto';
  };

  const handleLocaleChange = (id: string) => {
    const action = search[job_language_url_param] && search[job_language_url_param].includes(id.toString()) ?  'remove' : 'update' ;
    pushToSearch({ page: 0, [job_language_url_param]: id.toString() }, action);
  };

  return (
    <>
      <div className="company-header">
        <BrowserView renderWithFragment="true">
          <h3 className="title small">{t.filters.heading}</h3>
          <div className="jobs-search__buttons">
            {urlSearch.length > 0 && <BtnRounded
              text={t.btn.reset_filters}
              iconBefore="redo"
              handleClick={clearFilters}
            />}
            <BtnTransparent
              classes={showFilters ? ' active' : ''}
              text={t.btn.show_filters}
              iconBefore="settings"
              handleClick={() => toggleVisibility()}
            />
          </div>
        </BrowserView>
        <MobileView renderWithFragment="true">
          <BtnRounded
            classes={`btn_shadow${showFilters ? ' active' : ''}`}
            type='primary'
            text={t.btn.show_filters}
            iconBefore='settings'
            handleClick={handleClick}
          />
          {urlSearch.length > 0 && <BtnRounded
            text={t.btn.reset_filters}
            iconBefore="redo"
            type='default'
            handleClick={clearFilters}
          />}
        </MobileView>
      </div>
      <div className="company-header company-header-lang">
        <span>{t.jobs_for_lang}</span>

        <div className="filter_jobs filter_jobs-search">
          {locales.map(item => (
            <div key={item.id}
                 className={`filter__item${search[job_language_url_param] && search[job_language_url_param].includes(item.id.toString()) ? ' active' : '' }`}
                 onClick={() => handleLocaleChange(item.id)}>
            <div className="filter__name">{item.name}</div>
          </div>
          ))}
        </div>
      </div>
    </>
  );
};
